import React from "react";
import * as dateMath from 'date-arithmetic';
import { rng } from '../../../../../../../amorg-common';
import { Button } from "../../../../../../../designSystem/button/Button";
import { ButtonRow } from "../../../../../../../designSystem/button/ButtonRow";
import { Flex } from "../../../../../../../designSystem/compositeComponents/FlexHelpers";
import { LoadingPageOverlay } from "../../../../../../../designSystem/LoadingPageOverlay";
import { MessageCard } from "../../../../../../../designSystem/MessageCard";
import { ActionPlanListingPageSectionTable } from "../../../../../../_components/activities/ActionPlanListingPageSectionTable";
import { ActionPlanListView } from "../../../../../../../amorg-common/DTOs/ActionPlanListView";
import { getActionPlansBySurveyId, createActivityAndActionPlan } from "../../../../../../../api/actionPlanClientApi";
import { SurveyActionPlanStatusSection } from "../../_components/SurveyActionPlanStatusSection";
import { WorkplaceAssessmentComponentProps } from "../../_components/WorkplaceAssessmentComponentProps";
import { getSurveyStatusLabel } from "../../survey/_components/SurveyStatusPanel";
import { SingleColumnLayout } from "../../../../../../_layouts/SingleColumnLayout";
import { PageHeader } from "../../../../../../../designSystem/PageHeader";

type State = {
    actionPlansLoading: boolean,
    actionPlans: ActionPlanListView[]
};

type ActionPlansPanelListingProps = WorkplaceAssessmentComponentProps &
{
    onActionPlanSelected: (actionPlanId: string) => void;
};

export function ActionPlansPanelListing (props: ActionPlansPanelListingProps): JSX.Element
{

    const [state, setState] = React.useState<State>(
        {
            actionPlansLoading: true,
            actionPlans: []
        }
    );

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            await loadData();
        };        
        getData();
    }, [props.survey?.id]);

    async function loadData ()
    {
        if(props.survey === null)
        {
            setState({ actionPlansLoading: false, actionPlans: [] });
            return;
        }

        const actionPlans = await getActionPlansBySurveyId(props.survey.id);

        setState({
            actionPlansLoading: false,
            actionPlans
        });
    }

    async function handleClickCreateActionPlan ()
    {
        if(props.survey === null)
            return;

        const start = props.activity.end;
        const end = dateMath.add(start, 1, 'month');

        const result = await createActivityAndActionPlan(
            rng.getRandomId(),
            rng.getRandomId(),
            { type: 'WPA', customData: { surveyId: props.survey.id, segmentFilter: [] } },
            'Ny handleplan',
            start,
            end
        );
        if (result.isSuccess)
        {
            await loadData();
        }
    }

    return (
        <>
            <PageHeader
                headerText="APV - Handleplaner"
                subHeader={props.survey ? getSurveyStatusLabel(props.survey) : undefined}
            />

            <SingleColumnLayout>
                {state.actionPlansLoading &&
                    <LoadingPageOverlay loading={true} />
                }

            {(props.survey === null || props.survey.segmentations.length === 0) &&
                <>
                    {state.actionPlans.length === 0 &&
                        <MessageCard variant="info">
                            Der er ikke oprettet nogen handleplaner.<br />Tilføj en ny handleplan for at komme i gang.
                        </MessageCard>
                    }
                </>
            }

            {props.survey && props.surveyReport && props.survey.segmentations.length > 0 &&

                <SurveyActionPlanStatusSection 
                    headerText="Status på oprettelse af handleplaner" 
                    survey={props.survey} 
                    surveyReport={props.surveyReport} 
                    actionPlans={state.actionPlans} />
            }

            <Flex flexDirection="column" gap={16}>
                
                <ButtonRow variant="right-aligned">
                    <Button 
                        variant='light'
                        size={"42px"}
                        disabled={props.survey === null}
                        onClick={handleClickCreateActionPlan}
                        text={"Opret handleplan"}
                        icon="actions_plus"
                    />
                </ButtonRow>
                <ActionPlanListingPageSectionTable
                    items={state.actionPlans }
                    noContentText="Ingen handleplaner oprettet"
                    onClick={props.onActionPlanSelected}
                />

                
            </Flex>
            </SingleColumnLayout>
        </>
    );
}